module.exports = "/images/vendor/flag-icon-css/flags/4x3/kz.svg?740ef4bf1d15794bfbeb7a4ee804a760";